import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const GridItemContainer = (props: React.PropsWithChildren<ChakraV3.StackProps>) => {
  return <ChakraV3.Stack h='100%' overflow='hidden' {...props} />;
};
